import * as types from "../types";

export const login = ({ email, password }) => ({
  type: types.LOGIN,
  request: {
    url: "/login.json",
    method: "POST",
    data: {
      user: { email, password }
    }
  },
  meta: {
    mutations: {
      [types.GET_USER_ME]: (prevData, newData) => {
        return { ...prevData, data: newData.data };
      }
    }
  }
});

export const requestResetPassword = ({ email }) => ({
  type: types.REQUEST_RESET_PASSWORD,
  request: {
    url: "/users/password",
    method: "POST",
    data: {
      user: { email }
    }
  }
});

export const confirmResetPassword = ({ resetPasswordToken, password, passwordConfirmation }) => ({
  type: types.CONFIRM_RESET_PASSWORD,
  request: {
    url: "/users/password",
    method: "PATCH",
    data: {
      user: {
        resetPasswordToken,
        password,
        passwordConfirmation
      }
    }
  }
});

export const getUserMe = () => ({
  type: types.GET_USER_ME,
  request: {
    url: "/users/me",
    method: "GET"
  }
});

export const getCountries = () => ({
  type: types.GET_COUNTRIES,
  request: {
    url: "/countries",
    method: "GET"
  }
});

export const signUp = ({
  user: { email, password, passwordConfirmation, ...profileAttributes },
  accessCode
}) => ({
  type: types.SIGN_UP,
  request: {
    url: "/sign_up",
    method: "POST",
    data: {
      user: {
        email,
        password,
        passwordConfirmation,
        profileAttributes
      },
      accessCode
    }
  }
});

export const checkAccessCode = ({ accessCode }) => ({
  type: types.CHECK_ACCESS_CODE,
  request: {
    url: "/check_access_code",
    method: "POST",
    data: {
      accessCode
    }
  }
});

export const logout = () => ({
  type: types.LOGOUT,
  request: {
    url: "/logout.json",
    method: "DELETE"
  },
  meta: {
    mutations: {
      [types.GET_USER_ME]: prevData => {
        return { ...prevData, data: {} };
      }
    }
  }
});
